<template>
    <div id="signInForm" class="signInForm" :style="styles">
        <div class="signContainer align-items-center fullHeight">
            <div class="formCard">
                <div style="text-align:center">
                    <img border="0" :src="imgPath" width="120" height="120" alt="">
                </div>
                <h2 class="text-center pageTitles comment-color">ログイン</h2>
                <div>
                    <div class="form-group">
                        <input
                            type="text"
                            :class="{'is-invalid': valid.mail}"
                            class="form-control"
                            v-model="mail"
                            placeholder="メールアドレス"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div class="invalid-feedback" v-if="valid.mail">{{ valid_message.mail }}</div>
                    </div>
                    <div class="form-group form-check">
                        <input
                            v-model="mail_memory"
                            type="checkbox"
                            class="form-check-input"
                        />
                        <label class="form-check-label comment-color sign-color"
                        >次回以降自動で表示する</label>
                    </div>
                    <div class="form-group">
                        <input
                            type="password"
                            :class="{'is-invalid': valid.password}"
                            class="form-control"
                            v-model="password"
                            placeholder="パスワード"
                            @blur="checkInputData"
                            @input="checkInputData"
                        />
                        <div
                            class="invalid-feedback"
                            v-if="valid.password"
                        >{{ valid_message.password }}</div>
                        <button
                            type="button"
                            class="confirmbutton btn-block mt-3"
                            @click="memberLogIn"
                            @blur="checkInputData"
                            :disabled="submit_disabled.login"
                            :class="{ 'mypagedisabledbutton': submit_disabled.login }"
                        >ログイン</button>
                        <small class="form-text form-label-color">
                            ※パスワードを忘れた方は
                            <span class="passwordReset--Btn" @click="PasswordFormOpen">こちら</span>
                        </small>
                        <!-- <small class="form-text form-label-color">
                            ヘルプは
                            <span class="passwordReset--Btn" @click="testHelpAccess">こちら</span>
                        </small> -->
                    </div>
                    <div class="passwordReset" v-if="password_reset">
                        <div class="form-group">
                            <input
                                type="text"
                                :class="{'is-invalid': valid.mailReset}"
                                class="form-control mb-2"
                                v-model="mailReset"
                                placeholder="メールアドレス"
                                @blur="checkInputData"
                                @input="checkInputData"
                            />
                            <div
                                class="invalid-feedback"
                                v-if="valid.mailReset"
                            >{{ valid_message.mailReset }}</div>
                            <div class="row">
                                <div class="col">
                                    <input
                                        type="text"
                                        :class="{'is-invalid': valid.familyName}"
                                        class="form-control col"
                                        v-model="familyName"
                                        placeholder="姓"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.familyName"
                                    >{{ valid_message.familyName }}</div>
                                </div>
                                <div class="col">
                                    <input
                                        type="text"
                                        :class="{'is-invalid': valid.givenName}"
                                        class="form-control col"
                                        v-model="givenName"
                                        placeholder="名"
                                        @blur="checkInputData"
                                        @input="checkInputData"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        v-if="valid.givenName"
                                    >{{ valid_message.givenName }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="fpw_fail_msg" v-if="fpw_fail_msg">
                            <p>
                                <span class="text-danger">{{ this.fpw_msg}}</span>
                            </p>
                        </div>
                        <button
                            type="button"
                            class="btn-block"
                            @click="resettingPassBtn"
                            :disabled="submit_disabled.passwordReset"
                            :class="[ submit_disabled.passwordReset ? 'mypagedisabledbutton' : 'signupbutton' ]"
                        >パスワード再設定</button>
                    </div>
                    <div class="err_msg" v-if="api_error">
                        <p>
                            <span class="text-danger">{{ this.err_msg_txt }}</span>
                        </p>
                    </div>
                </div>
            </div>
            <div class="formCard formCard__left">
                <div class="lineLogin" v-if="snsSettingLine == 1">
                    <div class="lineBtn">
                        <div class="lineBtn__inner" @click="getSocialAuthUrl">LINEでログイン</div>
                    </div>
                    <div class="err_msg" v-if="line_login_error">
                        <p>
                            <span class="text-danger">{{ this.line_login_err_msg_txt}}</span>
                        </p>
                    </div>
                </div>
                <div class="my-1" v-if="snsSettingTwitter == 1">
                    <div class="twitterBtn">
                        <div class="twitterBtn__inner">Twitterでログイン</div>
                    </div>
                    <div class="err_msg" v-if="line_login_error">
                        <p>
                            <span class="text-danger">{{ this.line_login_err_msg_txt}}</span>
                        </p>
                    </div>
                </div>
                <div class="my-1" v-if="snsSettingFacebook == 1">
                    <div class="facebookBtn">
                        <div class="facebookBtn__inner">Facebookでログイン</div>
                    </div>
                    <div class="err_msg" v-if="line_login_error">
                        <p>
                            <span class="text-danger">{{ this.line_login_err_msg_txt}}</span>
                        </p>
                    </div>
                </div>
                <div class="singupArea comment-color">
                    <p>会員登録がお済みでない方</p>
                    <button
                        type="button"
                        class="signupbutton btn-block my-3"
                        @click="transitionSignupChoice"
                    >新規会員登録</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validater from "../../lib/validater";
import { createApollo } from "../../lib/apollo";
import {
    MEMBER_LOGIN,
    FORGOT_PASSWORD_MAIL,
    LINE_LOGIN,
    LOGIN_AT_LINE,
    UPDATE_TMP_DATA
} from "../../constants/signin";

export default {
    components: {
        validater
    },
    data() {
        return {
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            mail: "",
            password: "",
            mailReset: "",
            familyName: "",
            givenName: "",
            submit_disabled: {
                login: true,
                passwordReset: true
            },
            valid: {
                mail: false,
                password: false,
                mailReset: false,
                familyName: false,
                givenName: false
            },
            valid_message: {
                mail: "",
                password: "",
                mailReset: "",
                familyName: "",
                givenName: ""
            },
            // メールアドレス記録ボタン制御値
            mail_memory: false,
            // 利用規約のサンプル用データ
            password_reset: false,
            // LINEリッチメニューからのパラメータ
            line_link: "",
            url: "",
            providerName: "",
            operationType: "",
            accessToken: "",
            snsSettingLine: 0,
            snsSettingTwitter: 0,
            snsSettingFacebook: 0,
            //エラーメッセージ
            err_msg_txt: "",
            api_error: false,
            line_login_err_msg_txt: "",
            line_login_error: false,
            fpw_msg: "",
            fpw_fail_msg: false,
            height: '',
            notPasswordHeight: '',
            passwordHeight: ''
        };
    },
    created() {
        this.initialize();
    },
    mounted() {
        // スタイル変更用の画面高さ取得
        // 初期表示はパスワードフォーム非表示時の高さを取得
        this.notPasswordHeight = document.getElementById('signInForm').offsetHeight + 'px';
        this.height = this.notPasswordHeight;
    },
    computed: {
        // バインドするスタイルを生成
        styles () {
            return {
                '--height': this.height
            }
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
            // bodyタグのスクロール禁止クラスを外す。
            document.body.classList.remove('fix-body');

            // LINEリッチメニューからのパラメータを取得
            if (this.$route.query.line_link) {
                this.line_link = this.$route.query.line_link;
            }

            // メールアドレスの記憶状態チェック
            // 記憶時はアドレスならびに記憶チェック値をセット
            if (localStorage.getItem("mail-memory")) {
                this.mail = localStorage.getItem("login-mail");
                this.mail_memory = localStorage.getItem("mail-memory");
            }
            // SNS機能の利用有無を取得する
            this.snsSettingLine = this.$store.state.auth.settingValueLine;
            // LINEでログインする場合の処理
            if (this.$route.query.code) {
                let url =
                    process.env.MIX_GRAPHQL_URI +
                    "graphql?code=" +
                    this.$route.query.code;
                const client = createApollo(url);
                localStorage.removeItem("web-token");

                this.$store.commit("loading/setIsLoading", true);

                client
                    .query({
                        query: LOGIN_AT_LINE,
                        fetchPolicy: "no-cache",
                        variables: {
                            providerName: "line"
                        }
                    })
                    .then(res => {
                        localStorage.setItem(
                            "web-token",
                            res.data.memberLoginUsingSocial.accessToken
                        );
                        if (localStorage.getItem("line-link")) {
                            this.$router.push("/" + localStorage.getItem("line-link") + "?access_from_line=1");
                            localStorage.removeItem("line-link");
                        } else {
                            if (localStorage.getItem("friend-token")) {
                                this.$router.push("/friend-approval?token=" + localStorage.getItem("friend-token"));
                                localStorage.removeItem("friend-token");
                            } else {
                                this.$router.push("/mypage");
                            }
                        }
                    })
                    .catch(error => {
                        this.line_login_err_msg_txt = this.$t("error.validation.lineLoginError");
                        this.line_login_error = true;
                        this.$store.commit("loading/setIsLoading", false);
                    });
            }
        },

        PasswordFormOpen: function() {
            this.password_reset = !this.password_reset;
            let target = document.getElementById("signInForm");
            if (this.password_reset) {
                target.className = "forgotPasswordForm";

                if (this.passwordHeight === '') {
                    this.passwordHeight = document.getElementById('signInForm').offsetHeight + 'px';
                }
                this.height = this.passwordHeight;
            } else {
                target.className = "signInForm";
                this.height = this.notPasswordHeight;
            }
        },

        /** ------------------------------
         * ログイン処理
         * ------------------------------ */
        memberLogIn: async function() {
            localStorage.removeItem("web-token");
            this.$store.commit("loading/setIsLoading", true);
            try {
                let res = await this.$apollo
                    .query({
                        query: MEMBER_LOGIN,
                        fetchPolicy: "no-cache",
                        variables: { email: this.mail, password: this.password }
                    })
                    .catch(error => {
                        if (error.graphQLErrors[0].message == "Unauthorized") {
                            this.err_msg_txt = this.$t(
                                "error.validation.unmatchMailOrPassword"
                            );

                            this.api_error = true;
                        }
                    });

                localStorage.setItem(
                    "web-token",
                    res.data.memberLogin.accessToken
                );

                // メールアドレスの記憶状態セット処理
                if (this.mail_memory) {
                    localStorage.setItem(
                        "login-mail",
                        this.mail
                    );
                    localStorage.setItem(
                        "mail-memory",
                        this.mail_memory
                    );
                } else {
                    localStorage.removeItem("login-mail");
                    localStorage.removeItem("mail-memory");
                }

                if (this.line_link) {
                    this.$router.push("/" + this.line_link + "?access_from_line=1");
                } else {
                    // f:友達承認、r:予約（signin画面からの遷移先と仮データの登録対象のフラグ）
                    if (this.$route.query.type ==='f') {
                        if (this.$route.query.token) {
                            this.$router.push("/friend-approval?token=" + this.$route.query.token);
                        } else if (this.$route.query.id) {
                            this.$router.push("/friend-approval?id=" + this.$route.query.id);
                        }
                    } else if (this.$route.query.type ==='r') {
                        if (this.$route.query.id) {
                            await this.$store.dispatch('auth/getLoginMember');
                            // 取得が失敗した場合はunAuthorizedなので弾いてトップへ
                            if (!this.$store.state.auth.loginMember.member_no) {
                                this.$router.push("/");
                            }
                            await this.updateTmpData(this.$route.query.id, this.$store.state.auth.loginMember.member_no);
                        }
                        this.$router.push("/mypage");
                    } else if (this.$route.query.type ==='l') {
                        this.$router.push("/reserve-approval?cid=" + this.$route.query.cid);
                    } else if (localStorage.getItem("Reserve.returnBackUrl")){
                        this.$router.push(localStorage.getItem("Reserve.returnBackUrl"));
                    } else {
                        this.$router.push("/mypage");
                    }
                }
            } catch (error) {
                this.$store.commit("loading/setIsLoading", false);
            }
        },
        /**
         * LINEログインURL取得
         */
        updateTmpData: async function (id, memberNo) {
            await this.$apollo.mutate({
                    mutation: UPDATE_TMP_DATA,
                    variables: {
                        id: id,
                        member_no: memberNo
                    }
                });
        },
        /**
         * LINEログインURL取得
         */
        getSocialAuthUrl: function() {
            this.$store.commit("loading/setIsLoading", true);
            localStorage.removeItem("Auth.snsQueryToken");
            localStorage.removeItem("Auth.snsQueryID");
            // tokenがあればお友達承認画面
            if (this.$route.query.token) {
                localStorage.setItem('friend-token', this.$route.query.token);
            }
            if (this.$route.query.line_link) {
                localStorage.setItem('line-link', this.$route.query.line_link);
            }
            this.$apollo
                .query({
                    query: LINE_LOGIN,
                    variables: {
                        providerName: "line",
                        operationType: this.$store.state.auth.lineOperationType,
                        golf_code: localStorage.getItem("Reserve.golfCode")
                    }
                })
                .then(res => {
                    this.url = res.data.getSocialAuthUrl.url;
                    window.location.href = this.url;
                })
                .catch(error => {
                    this.$store.commit("loading/setIsLoading", false);
                });
        },

        /** ----------------------------------------------
         * バリデーションチェック
         * ---------------------------------------------- */
        checkInputData: function(event) {
            this.MessageClear();
            // メールアドレス形式
            if (this.mail) {
                if (!validater.checkMail(this.mail)) {
                    this.valid_message.mail = this.$t(
                        "error.validation.mailFormat"
                    );
                    this.valid.mail = true;
                } else if (!validater.checkStringLengthMax(this.mail, 256)) {
                    this.valid_message.mail = this.$t(
                        "error.validation.length.mail"
                    );
                    this.valid.mail = true;
                }
            }
            // パスワード
            if (this.password) {
                if (!validater.checkStringType(this.password)) {
                    this.valid_message.password = this.$t(
                        "error.validation.stringtype"
                    );
                    this.valid.password = true;
                } else if (!validater.checkStringLengthMin(this.password, 8)) {
                    this.valid_message.password = this.$t(
                        "error.validation.length.passwordMin"
                    );
                    this.valid.password = true;
                } else if (
                    !validater.checkStringLengthMax(this.password, 128)
                ) {
                    this.valid_message.password = this.$t(
                        "error.validation.length.passwordMax"
                    );
                    this.valid.password = true;
                }
            }
            // メールアドレス（再設定）形式
            if (this.mailReset) {
                if (!validater.checkMail(this.mailReset)) {
                    this.valid_message.mailReset = this.$t(
                        "error.validation.mailFormat"
                    );
                    this.valid.mailReset = true;
                } else if (
                    !validater.checkStringLengthMax(this.mailReset, 256)
                ) {
                    this.valid_message.mailReset = this.$t(
                        "error.validation.length.mail"
                    );
                    this.valid.mailReset = true;
                }
            }
            // 氏名姓チェック
            if (!validater.checkStringLengthMax(this.familyName, 50)) {
                this.valid_message.familyName = this.$t(
                    "error.validation.length.familyName"
                );
                this.valid.familyName = true;
            }
            // 氏名名チェック
            if (!validater.checkStringLengthMax(this.givenName, 50)) {
                this.valid_message.givenName = this.$t(
                    "error.validation.length.givenName"
                );
                this.valid.givenName = true;
            }
            this.disabledCheck();
        },
        /** ----------------------------------------------
         * ボタン制御処理
         * ---------------------------------------------- */
        disabledCheck: function() {
            // ログインボタン
            if (
                this.mail !== "" &&
                this.password !== "" && // 必要フォームに値があり
                this.valid.mail === false &&
                this.valid.password === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled.login = false; // ボタン押下可能
            } else {
                this.submit_disabled.login = true;
            }
            // パスワード再設定ボタン
            if (
                this.mailReset !== "" &&
                this.familyName !== "" &&
                this.givenName !== "" && // 必要フォームに値があり
                this.valid.mailReset === false &&
                this.valid.familyName === false &&
                this.valid.givenName === false // バリデーションに問題ない場合のみ
            ) {
                this.submit_disabled.passwordReset = false; // ボタン押下可能
            } else {
                this.submit_disabled.passwordReset = true;
            }
        },
        /** ----------------------------------------------
         * エラーメッセージクリア
         * ---------------------------------------------- */
        MessageClear: function() {
            this.valid_message.mail = "";
            this.valid.mail = false;
            this.valid_message.password = "";
            this.valid.password = false;
            this.valid_message.mailReset = "";
            this.valid.mailReset = false;
            this.valid_message.familyName = "";
            this.valid.familyName = false;
            this.valid_message.givenName = "";
            this.valid.givenName = false;
        },
        /** ----------------------------------------------
         * パスワード再設定処理
         * ---------------------------------------------- */
        resettingPassBtn: function() {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo
                .mutate({
                    mutation: FORGOT_PASSWORD_MAIL,
                    variables: {
                        email: this.mailReset,
                        family_name: this.familyName,
                        given_name: this.givenName
                    }
                })
                .then(res => {
                    this.$router.push("/passreset-mail");
                })
                .catch(error => {
                    this.$store.commit("loading/setIsLoading", false);
                    this.fpw_msg = error.graphQLErrors[0].message;
                    if (this.fpw_msg == "The given data was invalid.") {
                        this.fpw_msg =
                            error.graphQLErrors[0].extensions.validation.email[0];
                    }
                    this.fpw_fail_msg = true;
                });
        },
        testHelpAccess() {
            window.open('/help', '_blank');
        },
        /** ----------------------------------------------
         * 会員登録方法選択画面への遷移
         * ---------------------------------------------- */
        transitionSignupChoice() {
            if (this.$route.query.token) {
                this.$router.push("/signup?token=" + this.$route.query.token);
            } else if (this.$route.query.id) {
                this.$router.push("/signup?id=" + this.$route.query.id);
            } else if (!this.$route.query.gc || !this.$route.query.ud) {
                this.$router.push("/signup");
            } else {
                this.$router.push("/signup?gc=" + this.$route.query.gc + "&ud=" + this.$route.query.ud);
            }
        }
    }
};
</script>

<style scoped>
main {
    height: 100%;
}

@media screen and (max-width: 575px) {
    .forgotPasswordForm {
        padding-bottom: 42px;
    }
}
</style>
